module.exports = __webpack_public_path__ + "static/media/create.791824ef.svg";